import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { apiGet } from '../api'

const FacilityContext = createContext(null)

export const useFacility = () => useContext(FacilityContext)

export const FacilityProvider = ({ children }) => {
  const [facilities, setFacilities] = useState([])
  const [activeFacilityId, setActiveFacilityId] = useState(
    () => localStorage.getItem('activeFacilityId') || null
  )
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const loadFacilities = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      const res = await apiGet('/api/facilities/my')
      if (res.ok) {
        const data = await res.json()
        setFacilities(data)
        setActiveFacilityId((prev) => {
          if (prev && data.some((f) => f.id === prev)) return prev
          return data[0]?.id || null
        })
      } else {
        setError('Kunne ikke hente anlegg')
      }
    } catch (err) {
      setError('Feil ved lasting av anlegg: ' + err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadFacilities()
  }, [loadFacilities])

  useEffect(() => {
    if (activeFacilityId) localStorage.setItem('activeFacilityId', activeFacilityId)
  }, [activeFacilityId])

  const activeFacility = facilities.find((f) => f.id === activeFacilityId) || null

  return (
    <FacilityContext.Provider
      value={{
        facilities,
        activeFacility,
        activeFacilityId,
        setActiveFacilityId,
        loading,
        error,
        reload: loadFacilities
      }}
    >
      {children}
    </FacilityContext.Provider>
  )
}
